import { createSlice } from '@reduxjs/toolkit';
import {logoutUser,userDetail } from '../actions/Actions';

const initialState = {
  isLoggedIn:false,
  status: 'idle',
  error:null,
  data:[]
}

const createReducer = createSlice({
  isLoggedIn:false,
  name:"userData",
  initialState,
  reducers:{
  },
  extraReducers:(builder) => {
    builder
    // .addCase(loginUser.pending,(state)=>{
    //     state.status = 'loading'
    //   })
    //   .addCase(loginUser.fulfilled,(state,action)=>{
    //     state.status = 'fulfilled';
    //     state.isLoggedIn = true;
    //     state.data = action.payload;        
    //   })
    //   .addCase(loginUser.rejected,(state,error) => {
    //     state.status = 'rejected';
    //     state.error = error.error.message;
    // })
    .addCase(userDetail.fulfilled,(state,action)=>{
        state.status = 'fulfilled';
        state.isLoggedIn = true;
        state.data = action.payload;        
      })
      .addCase(userDetail.rejected,(state,error) => {
        state.status = 'rejected';
        state.error = error.error.message;
    })
    .addCase(logoutUser.fulfilled, (state,action) => {
      state.status = 'fulfilled';
      state.isLoggedIn = false;
      state.data = [];
    })
  }
})
export default createReducer.reducer;



